import { MbePackage, MbePickUp, MbeSafeValue } from '@/components/icons';
import { MbeSafeValueLogo } from '@/components/icons/MbeSafeValueLogo';
import { Section } from '@/components/shared';
import { Box, Button, Container, Flex, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IValueProps {
  content: string;
  heading?: React.ReactNode;
  icon: React.ElementType;
  title?: string;
}

const Value: React.FC<IValueProps> = (props): JSX.Element => {
  const { content, heading, icon: Icon, title } = props;

  return (
    <Box textAlign="center" w={{ base: '100%', lg: '33%' }}>
      <Icon h={32} w={32} />
      {heading ?? (
        <Heading
          as="h2"
          fontSize={{ base: 'h2.base', md: 'h2.md' }}
          fontWeight={{ base: 'normal', md: 'medium' }}
          my={2}
          size="xl"
        >
          {title}
        </Heading>
      )}
      <Text as="p" fontSize={{ base: 'medium', md: 'large' }}>
        {content}
      </Text>
    </Box>
  );
};

export const Values: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Section
      headingProps={{ mt: { base: 12, md: '120px' } }}
      id="values"
      title={t('LANDING.VALUES.SECTION_TITLE')}
    >
      <Container maxW="container.xl">
        <Flex
          alignItems={{ base: 'center', lg: 'flex-start' }}
          direction={{ base: 'column', lg: 'row' }}
          gap={10}
          justifyContent="space-between"
        >
          <Value
            content={t('LANDING.VALUES.ONE_CONTENT')}
            icon={MbePackage}
            title={t('LANDING.VALUES.ONE_TITLE')}
          />
          <Value
            content={t('LANDING.VALUES.TWO_CONTENT')}
            heading={
              <Heading as="h5" fontWeight="normal" my={2} size="xl">
                {t('LANDING.VALUES.TWO_TITLE')}
                <MbeSafeValueLogo h="auto" maxW={500} w="full" />
              </Heading>
            }
            icon={MbeSafeValue}
          />
          <Value
            content={t('LANDING.VALUES.THREE_CONTENT')}
            icon={MbePickUp}
            title={t('LANDING.VALUES.THREE_TITLE')}
          />
        </Flex>
      </Container>
      <Box textAlign="center">
        <Button as="a" href="/quote/user" variant="mbePrimary">
          {t('LANDING.VALUES.SECTION_CTA')}
        </Button>
      </Box>
    </Section>
  );
};
